import {
  useEffect,
  useState,
  Dispatch,
  SetStateAction,
  ReactElement,
} from 'react';
import CloseOutlined from '@ant-design/icons/CloseOutlined';
import clsx from 'clsx';

import { useCreateAppDefaultKeys } from 'new-components/OpAppNav/helpers/useCreateAppDefaultKeys';
import { OpNav } from 'new-components/OpNav/OpNav';
import { ProductBranding } from 'new-components/ProductBranding/ProductBranding';
import { OpRawMenuItemType } from 'config/createRawMenuItems';
import { OpButton } from 'new-components/DLS/OpButton/OpButton';
import { useOpQuery } from 'utils/customHooks/useOpQuery';
import { getOpParams } from 'utils/getOpParams';

import { BrandingLogo } from '../../../partnerCenterApp/pages/BrandingPage/components/BrandingLogo';

import { useCreateAppItems } from './helpers/useCreateAppItems';

import './OpAppNav.scss';

export const OpAppNav = ({
  items,
  title,
  onLogoClick,
  setIsShowingNavOnMobile,
  hidden,
  footer,
}: {
  items: OpRawMenuItemType[];
  title: string;
  onLogoClick?: () => void;
  setIsShowingNavOnMobile: Dispatch<SetStateAction<boolean>>;
  hidden?: boolean;
  footer?: ReactElement;
}) => {
  const [selectedPrimaryMenuKey, setSelectedPrimaryMenuKey] = useState<
    string | null
  >(null);

  const { orgId } = getOpParams();

  const navItems = useCreateAppItems({
    rawMenuItems: items,
    selectedPrimaryMenuKey,
    setSelectedPrimaryMenuKey,
  });

  const { defaultPrimaryKey, defaultSecondaryKey } = useCreateAppDefaultKeys({
    rawMenuItems: items,
  });

  useEffect(() => {
    setSelectedPrimaryMenuKey(defaultPrimaryKey);
  }, [defaultPrimaryKey]);

  const classes = clsx('op-app-nav', {
    'op-app-nav--hidden': hidden,
  });

  const { data: dmpCustomerOrg } = useOpQuery({
    apiEndpointName: 'describeOrg',
    enabled: !!orgId,
    parameters: [Number(orgId)],
    select: (res) => res.json.data ?? null,
  });

  return (
    <div className={classes} data-testid="op-app-nav">
      <div className="op-app-nav__close-button-container">
        <OpButton
          icon={<CloseOutlined />}
          onClick={() => setIsShowingNavOnMobile(false)}
        />
      </div>
      <OpNav
        logo={
          dmpCustomerOrg?.brandingPhoto?.url ? (
            <BrandingLogo url={dmpCustomerOrg.brandingPhoto?.url} />
          ) : (
            <ProductBranding label={title} testId={`${title}-logo`} />
          )
        }
        items={navItems}
        defaultPrimaryKey={defaultPrimaryKey}
        defaultSecondaryKey={defaultSecondaryKey}
        onLogoClick={onLogoClick}
        footer={footer}
      />
    </div>
  );
};
